// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"83b53546","98":"60b7fea0","147":"58b4ca87","171":"ad4398b7","429":"e8af6a18","453":"abd36b29","507":"b5f0bbf7","546":"21cb8d7f","567":"3270a115","594":"78ffdae3","780":"8d17e4c2","875":"40d5c998"}[chunkId] + ".chunk.js";
};